import { IsString, IsNotEmpty, IsIn, IsOptional } from 'class-validator';

export class FlowEdgeDto {
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  sourceId: string;

  @IsString()
  @IsNotEmpty()
  targetId: string;

  @IsIn(['main', 'secondary'])
  @IsOptional()
  condition?: 'main' | 'secondary';
}
